<div class="wrap">
    <mat-dialog-content>
    <h2>Update user</h2>
    <form [formGroup]="EditUserForm" #addUser (ngSubmit)="onSubmit()" *ngIf="!confirmAdd">
        <mat-form-field appearance="outline">
            <mat-label>{{'addUser.username.label' | translate}}*</mat-label>
            <input matInput formControlName="username">

        </mat-form-field>
        <mat-form-field appearance="outline">
            <mat-label>{{'addUser.email.label' | translate}}*</mat-label>
            <input matInput formControlName="email">


        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>{{'addUser.gsm.label' | translate}}</mat-label>
            <input matInput formControlName="gsm">
            <mat-hint align="end">
                For SMS alerts</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label> {{'addUser.client.label' | translate}}*</mat-label>
            <mat-select formControlName="client" [disabled]="true">
                <mat-option *ngFor="let c of clients" [value]="c?.name">{{c?.name}}</mat-option>
            </mat-select>
        </mat-form-field>

        <div class="application_title">
            <h5>Application(s)*</h5>
            <fa-icon [icon]="faPlus" (click)="onAddApplication()"></fa-icon>
        </div>


        <div class="application_inputs" formArrayName="applications">
            <p class="no_app" *ngIf="!applicationControls?.controls?.length">No app</p>
            <ng-container *ngIf="applicationControls?.controls?.length">
                <div class="app_content_inputs" *ngFor="let item of applicationControls.controls, let i = index;">
                    <div [formGroup]="item" *ngIf="item">
                        <mat-form-field appearance="outline">
                            <mat-label> {{'addUser.application.label' | translate}}*</mat-label>
                            <mat-select appearance="outline" formControlName="application" [compareWith]="compareApplication">
                                <ng-container *ngFor="let application of applications ">
                                    <mat-option [value]="application">
                                        {{application?.ApplicationName}}</mat-option>
                                </ng-container>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field appearance="outline" *ngIf="item.value.application">
                            <mat-label> {{'addUser.role.label' | translate}}*</mat-label>
                            <mat-select appearance="outline" formControlName="role" [compareWith]="compareRole">
                                <mat-option *ngFor="let r of roles" [value]="r" [disabled]="item.value.application.ApplicationName === 'Administration' && r.name === 'User'">{{r?.name}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <fa-icon [icon]="faTrashAlt" (click)="deleteApplicationInput(i)"></fa-icon>


                    </div>
                </div>
            </ng-container>
        </div>

        <div class="btn_action">
            <button class="canceled" type="button" (click)="dialog.closeAll()">Cancel</button>
            <button type="submit" [disabled]="EditUserForm.invalid"
                [ngClass]="{isInactive: EditUserForm.invalid, isActive: EditUserForm.valid }">
                Update</button>
        </div>
    </form>

    <div class="confirm" *ngIf="confirmAdd">
        <div class="validation_mail">
            <div class="check">
                <span class="icon-line line-tip"></span>
                <span class="icon-line line-long"></span>
                <div class="icon-circle"></div>
                <div class="icon-fix"></div>
            </div>
        </div>
        <h4>{{'addUser.confirmUpdate.label' | translate}}</h4>
    </div>
</mat-dialog-content>
</div>
